module.exports = __webpack_public_path__ + "static/ActaHeadline-BookItalic-1c28089943b5d33785c056ad6d1a6e66.woff2";